import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getSubscribersListPaged, getTotalSubscribers, exportWcSubscribers,removethisItem } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import {
  Collapse, CardBody, Card, CardHeader, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader
} from 'reactstrap';


import DataTable from 'react-data-table-component';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';

import BeWiseLoading from '../../../../src/assets/bewiseloading.gif';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';


class subscribersList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[],
      exportbtndisabled:false,  
      thisExportBtnText:'Export'
    }

    this.getTotal = this.getTotal.bind(this);
    this.getList = this.getList.bind(this);
  }


    getTotal = (vertical, location='') => {

      const { login_id, role } = this.state.auth_data;

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        vertical: vertical,
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotalSubscribers(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });


    }  

  componentDidMount() {

          var THIS = this;
      $(document).on('click', '.dlte', function () {
        var delete_id = $(this).data("id");
        
        if(confirm("You are sure to delete?")==true){

          let ins = JSON.stringify({
            id: delete_id,
            table:'wiseconnect'
          });

          removethisItem(ins).then((res) => {

            if(res.status==1){
              NotificationManager.success('Removed successfully');
            }else{
              NotificationManager.error('Issue in removing');
            }
            this.getTotal('leads');
            this.getList();

          });

      }


      });
      
      this.getTotal('leads');
      this.getList();

  }


      getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        perpage:this.state.PER_PAGE,
        year: this.state.year,
        month: this.state.month,
        offset:newOffset
      });

      getSubscribersListPaged(ins).then((res) => {

        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          

            const newLeads = res.data.map((lead) => ({
                "id": lead.id,
                "email": lead.email,
                "verified": lead.verified,
                "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
            }));

            this.setState({ list: newLeads});


        } else {

              this.setState({loading:!this.state.loading});
              
              this.setState({
                list: [],
              });
        }
      });


    }  
 

    handlePageChange(pageNumber) {

          console.log(`active page is ${pageNumber}`);

          this.setState({activePage: pageNumber});

          //this.getTotal('bw_schools');
          this.getList(pageNumber);


    }   


  subscribersExport = async () => {

    this.setState({exportbtndisabled:true, thisExportBtnText:"exporting..."});

    try {
      let req = JSON.stringify({
        location: this.state.location
      })
      const res = await exportWcSubscribers(req);
      if (res.status == 1) {

        this.setState({exportbtndisabled:false, thisExportBtnText:"Export"});
        console.log('location_list', res)
        console.log('location_list', res.path)
        window.open(res.path)

        // this.setState({
        //   subscribe_list: res.results,
        // });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  }      
 
  render() {
        const { list } = this.state;
        const { currentPage, PER_PAGE, totalCount, total, exportbtndisabled } = this.state;

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">List</h4>
                   
                   <div class="float-right"><button disabled={exportbtndisabled} class="btn btn-primary btn-sm"  onClick={() => this.subscribersExport()}>{this.state.thisExportBtnText}</button></div>
                
                 <div class="table-responsive pt-3">
                     <table class="table table-bordered table-sm">
                      <thead  class="thead-dark">
                        <tr>
                         
                          <th>S.No</th>
                          <th>Email</th>
                          <th>Date</th>
                          <th>Action</th>                          
                        </tr>
                      </thead>
                      <tbody>
                      {list.length>0 && list.map((lead, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          
                         
                          <td>{lead.email}</td>

                          <td>{lead.createdAt}</td>

                          <td><button class="dlte" data-id={lead.id}>Remove</button></td>
                        
                        </tr>

                      })

                      }

                      {list.length==0 && 

                      <tr><td colSpan="6">No data</td></tr>
                       }
                       
                      </tbody>
                    </table>


                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>

                  </div>
                    
 
                </div>
              </div>
            </div>  <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default subscribersList;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/subscriberslist.jsx